import React, { FC } from 'react'
import classNames from 'classnames'
import './IconX.less'
import { Box, HTMLChakraProps } from '@chakra-ui/react'

export interface IIconX {
  size?: 'small' | 'normal' | 'large'
  style?: React.CSSProperties
}

const IconX: FC<IIconX & HTMLChakraProps<typeof Box>> = (props) => {
  const { style, size, className, ...restProps } = props
  return (
    <Box
      style={style}
      className={classNames('IconX', size, className)}
      role="img"
      aria-label="Icon X"
      {...restProps}
    >
      <div className="IconX-line1"></div>
      <div className="IconX-line2"></div>
    </Box>
  )
}

export default IconX
